import React, {useEffect} from 'react';
import {Icon} from "@bonprix/design-system";
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import {SideSectionAction} from "@product/sections/SideSectionAction.tsx";
import SideSelectionItem from "../side-section/SideSelectionItem.jsx";
import StatsItem from "./StatsItem.jsx";
import ProductStatsAPI from "../../apis/product-stats-api.js";
import {useQuery} from "@tanstack/react-query";
import TrinityHelper from '@product/helper/trinity/trinity.ts';

export default function ProductStats({ texts, styleId }) {

    const {data: productStats, refetch} = useQuery({
        queryKey: ['productStats', styleId],
        queryFn: () => ProductStatsAPI.loadStatWithoutErrorCatch(styleId),
        refetchOnWindowFocus: false
    });

    const renderStats = (stats) => {

        const formatNumber = (number) => new Intl.NumberFormat('de-DE').format(number);

        return (
            <>
                {stats.viewStats !== null && (
                    <StatsItem text={`${formatNumber(stats.viewStats.count)} ${texts.ada_view_stats}`} iconVariant='visibility'/>
                )}
                {stats.wishListStats !== null && (
                    <StatsItem text={`${formatNumber(stats.wishListStats)} ${texts.ada_wishlist_stats}`} iconVariant='heart'/>
                )}
            </>
        );
    };

    useEffect(() => {
        const subscription = MessageBroker.subscribe('WISH_STATS.UPDATE', () => {
           refetch()
        });

        return () => MessageBroker.unsubscribe(subscription);
    }, [styleId]);

    useEffect(() => {
        if (productStats && productStats.viewStats !== null) {
            TrinityHelper.sendViewPpdEcInfos(styleId, String(productStats.viewStats.count), "views");
        }
        if (productStats && productStats.wishListStats !== null) {
            TrinityHelper.sendViewPpdEcInfos(styleId, String(productStats.wishListStats), "likes");
        }
    }, [productStats]);

    const showInfoIcon = productStats && (productStats.viewStats !== null || productStats.wishListStats !== null);

    const onProductStatsDetailsClicked = () => {
        const detailsComponent = (
            <>
                {productStats.viewStats !== null && (
                    <SideSelectionItem
                        iconName="visibility"
                        header={texts.ada_view_stats_explanation_header}
                        content={texts.ada_view_stats_explanation_content}
                    />
                )}
                {productStats.wishListStats !== null && (
                    <SideSelectionItem
                        iconName="heart"
                        header={texts.ada_wishlist_stats_explanation_header}
                        content={texts.ada_wishlist_stats_explanation_content}
                    />
                )}
            </>
        );

        MessageBroker.publish(SideSectionAction.OPEN, {
            nodes: {
                title: texts.ada_product_stat_explanation,
                content: detailsComponent
            }
        });

        TrinityHelper.sendClickPdpBasic('infobox_i');
    };

    return (
        <>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <div>{productStats ? renderStats(productStats) : null}</div>
                {showInfoIcon && (
                    <div
                        onClick={onProductStatsDetailsClicked}
                        style={{cursor: 'pointer', marginLeft: 'auto'}}
                    >
                        <Icon variant='hint'/>
                    </div>
                )}
            </div>
        </>
    );
}
